export const RESET_VERSIONING_VALUE = 'RESET_VERSIONING';
export type RESET_VERSIONING = typeof RESET_VERSIONING_VALUE;

export const SET_REQUESTED_API_VERSION_VALUE = 'SET_REQUESTED_APIVERSION';
export type SET_REQUESTED_API_VERSION = typeof SET_REQUESTED_API_VERSION_VALUE;

export const SET_VERSIONING_VALUE = 'SET_VERSIONING';
export type SET_VERSIONING = typeof SET_VERSIONING_VALUE;
